import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, FormGroup, Row } from "react-bootstrap";

import { ProfileStyled } from './styled/ProfileStyled';
import { useDispatch, useSelector } from "react-redux";
import { getUpdatePasswordProcess } from "../Auth/authSelectors";
import { updatePasswordAction } from "../Auth/authActions";
import FormPasswordEye from "../../components/PasswordTooltip/FormPasswordEye";

const Profile = ({ cancel }: { cancel?: () => void }) => {
    const updatePasswordStatus = useSelector(getUpdatePasswordProcess);
    const [prevState, setPrevState] = useState<null | string>(updatePasswordStatus);
    const dispatch = useDispatch();

    const submitChangePasswordHandler = useCallback((e) => {
        e.preventDefault();
        dispatch(updatePasswordAction({
            old_password: e.target.querySelector(`[name=old_password]`)?.value,
            new_password: e.target.querySelector(`[name=new_password]`)?.value,
            new_password_repeat: e.target.querySelector(`[name=new_password_repeat]`)?.value,
        }));
    }, [dispatch])

    useEffect(() => {
        if (updatePasswordStatus === null && typeof prevState === 'string') {
            cancel?.();
        }
        setPrevState(updatePasswordStatus)
    }, [cancel, updatePasswordStatus, prevState])

    return (
        <ProfileStyled>
            <h2>Change password</h2>
            <Form onSubmit={submitChangePasswordHandler}>

                <FormGroup as={Row} className="mb-3 align-items-center">
                    <Form.Label column sm={4}>Current password</Form.Label>
                    <Col>
                        <FormPasswordEye name="old_password" required={true}/>
                    </Col>
                </FormGroup>
                <FormGroup as={Row} className="mb-3 align-items-center">
                    <Form.Label column sm={4}>New password</Form.Label>
                    <Col>
                        <FormPasswordEye name="new_password" required={true}/>
                    </Col>
                </FormGroup>
                <FormGroup as={Row} className="mb-3 align-items-center">
                    <Form.Label column sm={4}>Confirm new password</Form.Label>
                    <Col>
                        <FormPasswordEye name="new_password_repeat" required={true}/>
                    </Col>
                </FormGroup>
                {
                    !!updatePasswordStatus && (
                        <p className={'text-danger'}>
                            {updatePasswordStatus}
                        </p>
                    )
                }
                <Button variant="primary" type="submit">
                    Save password
                </Button>
                {cancel ? (
                    <Button variant="primary" onClick={cancel} className="ms-3 align-items-right">
                        Cancel
                    </Button>
                ) : null
                }
            </Form>
        </ProfileStyled>
    );
}

export default Profile;
